export default {
  paymentListAdd: {
    paymentInfo: {
      auto: '自动生成',
      title: '付款单信息',
      paymentCompanyCode: '公司代码',
      paymentCompanyCodePlaceholder: '请选择公司代码',
      paymentMethod: '付款方式',
      paymentMethodPlaceholder: '请选择付款方式',
      paymentDate: '付款日期',
      paymentDatePlaceholder: '请选择付款日期',
      bankAccountName: '付款银行账户名称',
      bankAccountNamePlaceholder: '请选择付款银行账户名称',
      bankName: '付款银行',
      bankNamePlaceholder: '请输入付款银行',
      bankAccountNum: '付款银行账号',
      bankAccountNumPlaceholder: '请输入付款银行账号',
      receiveCompanyNo: '收款单位',
      openingBankNo: '开户银行',
      openingBankNoPlaceholder: '请选择开户银行',
      receiveBankAccountNum: '银行账号',
      bankUnionNumber: '联行号',
      bankBranch: '开户分行',
      paymentType: '付款类别',
      paymentTypePlaceholder: '请选择付款类别',
      paymentAmount: '付款金额',
      paymentAccountedAmount: '付款金额本位币',
      currencyCode: '币种',
      currencyCodePlaceholder: '请选择币种',
      exchangeType: '汇率类型',
      exchangeTypePlaceholder: '请选择汇率类型',
      exchangeRate: '汇率',
      exchangeRatePlaceholder: '请选择汇率',
      exchangeRateDate: '汇率日期',
      exchangeRateDatePlaceholder: '请输入汇率日期',
      isVirtual: '虚拟标识',
      requestStatus: '单据状态',
      requestNum: '单据编号',
      bankDocumentNum: '银行单号',
      paymentCreatePersonNo: '制单人',
      paymentCreateDate: '制单日期',
      paymentCreateDatePlaceholder: '请选择制单日期',
      summaryPlaceholder: '请输入摘要',
      isDirectConnectionToBank: '银企直连标识',
      summary: '摘要',
      paymentUsage: '汇款用途',
      paymentUsagePlaceholder: '请输入汇款用途',
    },
    accountingInfo: {
      title: '会计信息',
      cashFlowItemCode: '现金流量事务代码',
      accountedDate: '入账日期',
      voucherCode: '凭证编号',
      reversePostDate: '冲销入账日期',
      reverseVoucherCode: '冲销凭证编号',
      cashAccCode: '付款科目代码',
      cashAccName: '付款科目名称',
      liabilityAccCode: '应付科目代码',
      liabilityAccName: '应付科目名称',
      accountingStatus: '入账状态',
      reverseStatus: '冲销入账状态',
    },
    creditInfo: {
      creditLetterCode: '信用证编号',
      amount: '金额',
      writeOffEntryDate: '合计',
    },
    invoiceLine: {
      title1: '行信息',
      title2: '票据信息',
      title3: '信用证信息',
      title4: '会计凭证',
      table: {
        lineNumber: '行号',
        paymentApplyNumber: '申请单号',
        paymentApplyLineNumber: '申请单行号',
        paymentApplyDepartmentName: '部门描述',
        requestAmount: '申请金额',
        payedAmount: '已付款金额',
        paymentAmount: '付款金额',
        paymentAmountPlaceholder: '请输入付款金额',
        paymentAccountedAmount: '付款金额本位币',
        exchangeRate: '汇率',
        purchaseOrderNo: '采购合同号',
        purchaseOrderDetailNo: '采购合同行项目号',
        productName: '商品描述',
        invoiceCode: '发票编号',
        salesOrderNo: '销售合同号',
        salesLadingNo: '销售提单号',
        currencyCode: '币种',
        businessPersonNo: '业务员',
        settleBatchNo: '结算批次号',
        instructionNo: '供应商发货指令',
        mark: '备注',
        orderUnpaidAmount: '冲销标识',
        total: '合计',
      },
      billInfo: {
        lineNumber: '行号',
        departmentCode: '部门',
        billCode: '票据号',
        billAmount: '票据金额',
        billType: '票据类型',
        total: '合计',
        billCodePlaceholder: '请选择票据号',
      },
      creditInfo: {
        lineNumber: '行号',
        creditLetterCode: '信用证编号',
        billCode: '金额',
        total: '合计',
      },
      rules: {
        input: '请填写',
        select: '请选择',
      },
    },
    btns: {
      save: '保存',
      payment: '确认付款',
      generateCredentials: '生成凭证',
      writeOff: '冲销',
    },
    prompt: {
      writeOffEntryDate: '请选择冲销日期',
      accountEntryDate: '请选择入账日期',
    },
    warnInfo: {
      infoInfo: '请填写发票信息',
    },
    message: {
      canNotSelLC: '当前付款方式不能选择信用证L/C，请重新选择！',
      rateInfo: '缺少对应汇率，请维护！',
      calcInfo: '付款金额必需≤未付款金额，请重新输入！',
      noBill: '还未填写票据信息！',
      cancelled: '已取消！',
      deleteSuccess: '删除成功！',
      noData: '您还未选择任何数据！',
    },
  },
};
